
import React, { useRef } from 'react';
import { Box, Card, Divider, TableBody, TextField } from '@mui/material';
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import Edit from "../../../icons/edit.svg";
import Trash from "../../../icons/trash1.svg";
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import { useState, useEffect } from 'react';
import { MenuItem, Checkbox, ListItemText } from "@mui/material";
import Select from "@mui/material/Select";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';

import _ from "lodash";
import axios from '../../../utils/fvAxios';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Nodata from "../../Nodata/Nodata";
import Paginator from "../../../toolkit/Paginator";
import { ToastContainer, toast } from "react-toastify";
import { HasPermissions } from '../../../utils/Token';
import INFO from '../../../pages/commom/RouteUrlInfo.json';
import PER from "../../../utils/Enums.json";

export default function InvitationCCSetup() {

    const StyledTableCell = styled(TableCell)(({ theme }) => ({
        [`&.${tableCellClasses.head}`]: {
            backgroundColor: theme.palette.action.hover,

        },
        [`&.${tableCellClasses.body}`]: {
            fontSize: 14,
        },
        // hide last border
        '&:last-child td, &:last-child th': {
            border: 0,
            marginBottom: "20px"
        },
    }));

    const menuListRef = useRef(null);
    const scrollToTopOfOtions = () => {
        setTimeout(() => {
            if (menuListRef.current) {
                const children = menuListRef.current.children;
                if (children.length >= 2) {
                    const secondLastOption = children[children.length - 2];
                    if (secondLastOption) {
                        secondLastOption.scrollTop = 0;
                    }
                }
            }
        }, 5);
    };

    const toastNotify = (message, isSuccess = true) => {
        if (isSuccess) {
            toast.success(message, {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        } else {
            toast.error(message, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        }
    };
    const MenuProps = {
        PaperProps: {
            style: {
                maxHeight: 50 * 5 + 8,
                width: 200,
            },
        },
    };
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

    const [open, setOpen] = useState(false);
    const [Tab, setTab] = useState("");
    const [spinner, setSpinner] = React.useState(false);
    const [emailListId, setEmailListId] = useState([]);
    const [ClientUsers, setClientUsers] = React.useState([]);
    const [Count, setCount] = useState("");
    const [ClientList, setClientList] = React.useState([]);
    const [clientId, setClientId] = React.useState("");
    const [EmailList, setEmailList] = React.useState([]);
    const [number, setNumber] = useState("1");
    const [Search, setSearch] = useState("");
    const [id, setID] = useState("");
    const [state, setSate] = useState(false);

    useEffect(() => {
        GetClientUsers("");
    }, [number, Search]);

    useEffect(() => {
        Details();
    }, []);

    async function GetClientUsers(val) {
        const num = val != "" ? val : number;
        setSpinner(!spinner);
        const res = await axios.get("SystemUser/GetClientUsers?pagesize=12&pageNumber=" + num + "&filters=" + Search + "&type=1");
        setClientUsers(res?.data?.data);
        setCount(res?.data?.count);
        setSpinner(spinner);
    }
    async function Details() {
        const res = await axios.get("Prequalification/GetAllClients?getAll=false&isIncludeMultiClient=false");
        setClientList(res?.data?.data);
    }
    const ChangeClient = async (val) => {
        setClientId(val);
        const res = await axios.get("SystemUser/GetClientUsersData?ClientId=" + val);
        setEmailList(res?.data?.data);
    }
    const SpinnerClose = () => {
        setSpinner(false);
    };
    const FreeSearch = (e) => {
        setSearch(e);
        setNumber("1");
    }


    const handlePageChange = (event) => {
        setNumber(event);
    };

    const OpenTab = (num, p) => {
        setSate(false)
        setTab(num);
        setOpen(true);
        setClientId(num == 2 ? p?.clientID : "");
        ChangeClient(num == 2 ? p?.clientID : "");
        setID(num == 2 || num == 3 ? p?.id : "0");
        setEmailListId(num == 2 ? p?.userIds.split(",").map(r => r.trim()) : []);
    };

    const CloseTab = () => {
        setOpen(false);
        setSate(false);
    };

    const AddorUpdate = async () => {
        setSate(true);
        if (Tab == 1 || Tab == 2) {
            if (emailListId != "") {
                const data = {
                    "userIds": _.toString(emailListId),
                    "clientId": clientId,
                    "id": id,
                    "type": 1
                }
                axios.post("SystemUser/SaveClientInvitationEmails", data)
                    .then((res) => {
                        if (res?.data) {
                            CloseTab();
                            GetClientUsers(1);
                            toastNotify(res?.data?.data, true);
                        } else {
                            toastNotify(res?.data?.responseMessage, false);
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                    })
                    .finally(() => {
                        setSate(false);
                    });

            } else {
                toastNotify("Please enter mandatory fields", false);
                setSate(false);
            }
        } else {
            const res = await axios.post("SystemUser/DeleteClientNotification?id=" + id);
            if (res?.data?.responseCode == 100) {
                toastNotify(res?.data?.responseMessage, true);
                GetClientUsers(1);
                CloseTab();

            } else {
                toastNotify(res?.data?.responseMessage, false);
                setSate(false);
            }

        }
    }

    return (
        <>
            <ToastContainer />
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={spinner}
                onClick={SpinnerClose}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
            <Dialog fullScreen={fullScreen} open={open} onClose={CloseTab}>
                <DialogContent sx={{ padding: "48px 48px" }}>
                    <DialogTitle
                        sx={{
                            textAlign: "center",
                            fontWeight: 500,
                            fontSize: 20,
                        }}
                    >
                        <span style={{ fontSize: "larger" }} >{Tab == 3 ? "Delete Invitation " : Tab == 1 ? " Add Invitation Reminders  " : " Edit Invitation Reminders "}</span><br /><span style={{ fontSize: "larger" }} >CС Setup </span>
                    </DialogTitle>

                    <DialogActions >
                        <div>
                            {Tab == 3 ? " Do you want to delete this Invitation ?" :
                                <div className='mx-2'>
                                    <div >
                                        <span style={{ color: "#3E4A62" }}> Client  <span style={{ color: "red" }}>*</span></span>
                                        <br />
                                        <Select
                                            sx={{
                                                '& legend': { display: 'none' },
                                                '& fieldset': { top: 0 },
                                                width: "320px"
                                            }}
                                            labelId="demo-multiple-name-label"
                                            value={clientId || ""}
                                            id="demo-multiple-name"
                                            size="small"
                                            onChange={(e) => ChangeClient(e.target.value)}
                                            MenuProps={MenuProps}
                                            disabled={Tab == 2}
                                        >
                                            {ClientList?.map((r, i) =>
                                                <MenuItem key={i} value={r?.value} > {r?.text}</MenuItem>
                                            )}
                                        </Select>

                                    </div>
                                    <div className='mt-2' >
                                        <span style={{ color: "#3E4A62" }}>  Client Users  <span style={{ color: "red" }}>*</span></span>
                                        <br />
                                        <Select
                                            labelId="docs-label"
                                            id="docs-select"
                                            multiple
                                            size='small'
                                            sx={{ width: "320px", overflow: "hidden" }}
                                            name="Site Safety Representive"
                                            value={emailListId || []}
                                            MenuProps={{
                                                ref: menuListRef,
                                                PaperProps: MenuProps.PaperProps,
                                            }}
                                            renderValue={(selected) =>
                                                selected
                                                    .map((value) => EmailList?.find((doc) => doc?.userId === value)?.name)
                                                    .filter((text) => text !== undefined)
                                                    .join(", ")
                                            }
                                            onChange={(e) => setEmailListId(e.target.value)}
                                        >
                                            <MenuItem key="Select All">
                                                <Checkbox
                                                    id="select-all-checkbox"
                                                    indeterminate={
                                                        emailListId?.length > 0 && emailListId?.length < EmailList?.length
                                                    }
                                                    checked={emailListId?.length === EmailList?.length}
                                                    onChange={(event) => {
                                                        if (event?.target?.checked) {
                                                            setEmailListId(EmailList?.map((doc) => doc?.userId));
                                                            scrollToTopOfOtions();
                                                        } else {
                                                            setEmailListId([]);
                                                        }
                                                    }}
                                                />
                                                <label htmlFor="select-all-checkbox" style={{ fontSize: "16px", fontWeight: "500", color: "rgba(0, 0, 0, 0.87)", width: "320px", cursor: "pointer" }}>
                                                    Select All
                                                </label>
                                                {/* <ListItemText primary="Select All" /> */}
                                            </MenuItem>
                                            {EmailList?.map((r, i) => (
                                                <MenuItem key={i} value={r?.userId}   >
                                                    <Checkbox checked={emailListId?.indexOf(r?.userId) > -1} />
                                                    <ListItemText primary={r?.name} hidden={r?.name == "" ? true : false} />
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </div>
                                </div>
                            }
                            <DialogActions >
                                <div className="login-help__buttonContainer mt-4">
                                    <Button variant="contained" className="login-help-button-cancel mx-2" onClick={CloseTab}>Cancel</Button>
                                    <Button variant="contained" className="login-button-request mx-2" disabled={state == true} onClick={AddorUpdate}>{Tab == 3 ? "Ok" : Tab == 1 ? "Add " : "Save"}</Button>
                                </div>

                            </DialogActions>
                        </div >

                    </DialogActions>

                </DialogContent>
            </Dialog >
            <Card>
                <div style={{ marginLeft: "10px", marginTop: "10px" }}>
                    <div style={{ marginLeft: "15px", marginBottom: "15px" }}>
                        <Stack spacing={2} direction="row">
                            <h3>Invitation Reminders CС Setup</h3>
                            <div style={{ marginLeft: "Auto", padding: "10px" }}>
                                {HasPermissions(INFO?.AddInviteNotifications?.actionName, PER?.ScreenPermissions?.Insert) &&
                                    <Button variant="contained" sx={{ padding: "inherit" }} onClick={() => OpenTab(1, "")}  >+ Add New</Button>
                                }
                            </div>
                        </Stack >
                    </div>
                </div>
                <Divider sx={{ marginTop: 2, marginBottom: 2, backgroundColor: "#667085;", height: "2px" }} />
                <div style={{ marginLeft: "15px", marginBottom: "15px" }}>
                    <TextField size='small' placeholder='Search' value={Search} onChange={(e) => FreeSearch(e.target.value)} />
                </div>
                <Box sx={{ backgroundColor: '#f8f9fa' }}>
                    {ClientUsers < 1 ?
                        <div hidden={spinner}>
                            <Box border={1} borderLeft={1} borderRight={1} borderColor="#e4e7ec" sx={{ padding: 2, marginTop: 4, marginRight: "12px", width: "auto" }} className="text-center">
                                <span style={{ color: "#667085" }}>No Notifications found</span>
                            </Box></div> : <>
                            <TableContainer component={Paper} sx={{ borderBottom: 0 }}>
                                <Table aria-label="customized table">

                                    <TableHead>
                                        <TableRow>
                                            <StyledTableCell ><span style={{ color: "#667085", fontSize: "16px" }}> Client Name</span></StyledTableCell>
                                            <StyledTableCell ><span style={{ color: "#667085", fontSize: "16px" }}> User Email's</span></StyledTableCell>
                                            <StyledTableCell ><span style={{ color: "#667085", fontSize: "16px" }}> Users</span></StyledTableCell>
                                            <StyledTableCell >&nbsp;</StyledTableCell>
                                            <StyledTableCell >&nbsp;</StyledTableCell>

                                        </TableRow>
                                    </TableHead>


                                    {ClientUsers?.map((r, i) => (
                                        <TableBody key={i}>

                                            <TableRow key={i}>

                                                <StyledTableCell sx={{ width: "20%" }}>
                                                    {r?.clientName}
                                                </StyledTableCell>

                                                <StyledTableCell sx={{ width: "20%" }}>
                                                    {r?.usersEmails}
                                                </StyledTableCell>

                                                <StyledTableCell sx={{ width: "20%" }}>
                                                    {r?.userNames}
                                                </StyledTableCell>

                                                <StyledTableCell sx={{ width: "5%" }} >
                                                    {HasPermissions(INFO?.AddInviteNotifications?.actionName, PER?.ScreenPermissions?.Modify) &&
                                                        <IconButton aria-label="edit" onClick={() => OpenTab(2, r)}>
                                                            <img src={Edit} alt="editicon" />
                                                        </IconButton>
                                                    }
                                                </StyledTableCell>

                                                <StyledTableCell sx={{ width: "5%" }}>
                                                    {HasPermissions(INFO?.AddInviteNotifications?.actionName, PER?.ScreenPermissions?.Delete) &&
                                                        <IconButton aria-label="delete" onClick={() => OpenTab(3, r)} >
                                                            <img src={Trash} alt="trashicon" />
                                                        </IconButton>
                                                    }
                                                </StyledTableCell>

                                            </TableRow>

                                        </TableBody>
                                    ))}
                                </Table>

                            </TableContainer>
                        </>}
                </Box >

            </Card>
            <div hidden={Count < 1}>
                <Paginator
                    count={Math.ceil(Count / 12)}
                    page={Number(number)}
                    margin="18px 0px"
                    onChange={handlePageChange}
                />
            </div>

        </>
    )
}



